'use client';

import { useSearchParams } from 'next/navigation';
import {
  createContext,
  Fragment,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState
} from 'react';

const NotFoundResetContext = createContext<() => void>(() => {});

export const NotFoundResetProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [generation, setGeneration] = useState(0);
  const reset = useCallback(() => setGeneration(value => value + 1), []);

  return (
    <NotFoundResetContext.Provider value={reset}>
      <Fragment key={generation}>{children}</Fragment>
    </NotFoundResetContext.Provider>
  );
};

export const ResetNotFoundOnSearchChange = () => {
  const reset = useContext(NotFoundResetContext);
  const search = useSearchParams().toString();
  const [notFoundSearch] = useState(search);

  useEffect(() => {
    if (search !== notFoundSearch) reset();
  }, [search, notFoundSearch, reset]);

  return null;
};
